import { IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { CalculoComponenteResponse, ProjetosProvider } from "src/providers/ProjetosProvider";
import { ListagemItem } from "../../types";
import { ComponenteSolucaoHibrido } from "src/store/vendas/projetos/hibrido/hibrido.types";
import { VALOR_MULTIPLO_CABO } from "../../constants";

interface CalcularAcessoriosInput {
  moduloId: number;
  regioes: number[]
  quantidade_modulos: number;
  inversores: ComponenteSolucaoHibrido[]
  projetoFiname?: boolean;
}

const projetosProvider = new ProjetosProvider();

export const calcularAcessorios = async ({ inversores, moduloId, regioes, quantidade_modulos, projetoFiname = false }: CalcularAcessoriosInput): Promise<IDataResponse<(ListagemItem & { quantidade_minima_finame: number })[]>> => {
  const calculoAcessoriosResponse = await projetosProvider.calcularAcessorios(moduloId, {
    regiao_id: regioes,
    quantidade_modulos: quantidade_modulos,
    segmento: 'on',
    inversores: (inversores || []).length > 0 ? inversores.map(item => ({
      categoria_componentes_id: item.categoria_componentes_id,
      id: item.id,
      quantidade: item.quantidade,
    }) ) : [],
  })

  if (calculoAcessoriosResponse.statusCode !== STATUS_CODE.OK) {
    return {
      ...calculoAcessoriosResponse,
      data: [],
    };
  }

  let acessoriosOutput: (CalculoComponenteResponse & { quantidade_minima_finame: number })[] = calculoAcessoriosResponse.data.map(item => ({ ...item, quantidade_minima_finame: 0 })) || [];

  if (projetoFiname) {
    acessoriosOutput = calculoAcessoriosResponse.data.map(item => {
      const tipoCaboAttr = (item.atributos || []).find(item => item.atributo === 'TIPO_CABO')
      const tipoCabo = tipoCaboAttr ? Number(tipoCaboAttr?.valor) : null;
      const ignorarRegraQtdMinima = !tipoCabo || tipoCabo === 3;

      const qtd = ignorarRegraQtdMinima ? item.quantidade : Math.max(item.quantidade, VALOR_MULTIPLO_CABO);
      const qtdMinimaFiname = ignorarRegraQtdMinima ? 0 : VALOR_MULTIPLO_CABO;

      return {
        ...item,
        quantidade: qtd,
        quantidade_minima_finame: qtdMinimaFiname,
      };
    })
  }

  return {
    ...calculoAcessoriosResponse,
    data: acessoriosOutput.map(item => {
      return {
        altura: Number(item.altura || 0),
        categoria_componentes_id: Number(item.categoria_componentes_id || 0),
        componente_id: Number(item.id || 0),
        descricao: String(item.descricao || ''),
        largura: Number(item.largura || 0),
        nome: item.nome_componente,
        peso: Number(item.peso || 0),
        potencia: 0,
        quantidade: item.quantidade ?? 0,
        quantidade_original: item.quantidade ?? 0,
        valor: 0,
        valor_unitario: 0,
        exibir_popup_parceiro: false,
        quantidade_minima_finame: item.quantidade_minima_finame || 0,
      }
    })
  }
}